import { Outlet } from "react-router-dom";
import { InternalProvider, APIClientInterface, AppState } from "./context/InternalContext";

export interface InternalLayoutProps {
  currentTenant: string;
  apiClient: APIClientInterface;
  appState: AppState;
}

/**
 * Layout component that wraps internal routes with the InternalProvider context.
 *
 * Internal routes can access app state via useAppState hook, which returns
 * the app state passed from the web application.
 *
 * Use with React Router's layout route pattern:
 *
 * @example
 * ```tsx
 * <Route element={<InternalLayout currentTenant={tenant} apiClient={api} appState={state} />}>
 *   <Route path="/langfuse" element={<Langfuse />} />
 *   <Route path="/evals" element={<Evals />} />
 *   <Route path="/ade-bench" element={<AdeBench />} />
 * </Route>
 * ```
 */
export const InternalLayout: React.FC<InternalLayoutProps> = ({
  currentTenant,
  apiClient,
  appState,
}) => (
  <InternalProvider currentTenant={currentTenant} apiClient={apiClient} appState={appState}>
    <Outlet />
  </InternalProvider>
);
